import { IModuleFeatureQuery } from '../interfaces/module-feature.query.interface';

export class ModuleFeature {
    static props_to_search = ['id'];

    id: string;
    status: string;

    constructor(feature: IModuleFeatureQuery) {
        this.id = feature.name;
        this.status = feature.status;
    }
}
